module.exports = __webpack_public_path__ + "img/PS_offerings.eefb02c3.png";